<template>
  <div class="test-modals-component ">
    <button @click="openModal('PaymentModalOpen', 'https://loremflickr.com/240/240/brazil,rio')">PaymentModalOpen 1</button>
    <button @click="openModal('PaymentModalOpen')">PaymentModalOpen 2</button>
    <button @click="openModal('VerificationStatusOpen')">VerificationStatusOpen</button>
    <button @click="openModal('BuyMediaModalOpen',{url:'https://loremflickr.com/240/240/brazil,rio', price: 123})">BuyMediaModalOpen</button>
    <button @click="openModal('BuyProfileModalOpen',{avatarUrl:'https://loremflickr.com/240/240/brazil,rio', profileId: -1})">BuyProfileModalOpen</button>
    <button @click="openModal('PushNotificationModalOpen')">PushNotificationModalOpen</button>

    <button @click="openModal('ReportModalOpen',-1)">ReportModalOpen</button>
    <button @click="openModal('PhotoReportModalOpen',-1)">PhotoReportModalOpen</button>
    <PhotoReportModal></PhotoReportModal>
    <hr>
    <button @click="notificationModalOpenShow1=true">SendUserInformation NotificationModalOpen1</button>
    <button @click="notificationModalOpenShow2=true">SendUserInformation NotificationModalOpen2</button>
    <button @click="notificationModalOpenShow3=true">SendUserInformation NotificationModalOpen3</button>
    <hr>
    <button @click="notificationModalOpenShow4=true">NotificationModalOpen4</button>
    <button @click="notificationModalOpenShow5=true">NotificationModalOpen5</button>

    <NotificationModal v-model="notificationModalOpenShow1" :isBaseModal="false" :isPopupModal="false" :notification="{data: notificationData, type: 'App\\Notifications\\Admin\\SendUserInformation'}"></NotificationModal>
    <NotificationModal v-model="notificationModalOpenShow2" :isBaseModal="false" :isPopupModal="false" :notification="{data: notificationDataInfo, type: 'App\\Notifications\\Admin\\SendUserInformation'}"></NotificationModal>
    <NotificationModal v-model="notificationModalOpenShow3" :isBaseModal="false" :isPopupModal="false" :notification="{data: notificationDataWarning, type: 'App\\Notifications\\Admin\\SendUserInformation'}"></NotificationModal>


    <NotificationModal v-model="notificationModalOpenShow4" :isBaseModal="true" :isPopupModal="false" :notification="{data: notificationData, type: 'App\\Notifications\\CustomPopupNotification'}"></NotificationModal>
    <NotificationModal v-model="notificationModalOpenShow5" :isBaseModal="false" :isPopupModal="true" :notification="{data: notificationData, type: 'daily_reward'}"></NotificationModal>

  </div>
</template>
<script>

import { mapGetters } from 'vuex';

import PhotoReportModal from '../Profile/PhotoReportModal';
import NotificationModal from '../Notification/NotificationModal';

export default {
  components: { PhotoReportModal, NotificationModal },
  data() {
    return {
      notificationModalOpenShow1: false,
      notificationModalOpenShow2: false,
      notificationModalOpenShow3: false,
      notificationModalOpenShow4: false,
      notificationModalOpenShow5: false,
      notificationData: {
        title: 'title',
        message: 'some more or less fancy message',
        header: 'asdasdasdasd',
        slogan: 'asdasdasdasd',
        top_text: 'asdasdasdasd',
        picture: 'https://loremflickr.com/240/240/brazil,rio',
        bottom_text: 'bottom_text',
        button_web_link: null,
        button_text: 'button_text',
      }
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
    notificationDataInfo: function () {
      let data = { ...this.notificationData };
      data.title = data.title + ' info';
      data.category = 'info';
      return data;
    },
    notificationDataWarning: function () {
      let data = { ...this.notificationData };
      data.title = data.title + ' warning';
      data.category = 'warning';
      return data;
    },
  },
  methods: {
    openModal(type, param) {
      console.log('open moDal emit');
      console.log(type);
      console.log(param);
      this.$eventHub.$emit(type, param);
    }
  },
  mounted() {

  }
};
</script>
